/**
 * NE4: MEINE AUFTRÄGE (.590), für Firma und Team.
 *
 * ORIGINALTEXT MARVIN (02.11.2026)
 *   „Und die Aufträge dann als solches, die zugewiesen sind und in welchem
 *    Status mit den Informationen, mit den Kommentaren und. Das sind ja die
 *    Informationen, die wir ja auch weitergeben, so wie bei NE3,
 *    Dateistruktur, dass da was hochgeladen werden kann, etc. ... Sonst können
 *    die ja gar nichts machen."
 *
 * Links die Häuser mit Termin der eigenen Teams, rechts das gewählte Haus:
 * Zustand, Termine, Ansprechpartner, Connects, Infos (freigegeben und eigene)
 * und Dateien in Ordnern mit Hochladen. Keine Preise, keine Dispo-Interna.
 */
import { useEffect, useState } from 'react';
import { offenAusAdresse, offenInAdresse } from '../teile/adresse.ts';
import { api, darf, datum, zeitpunkt, type Anmelder } from '../api.ts';
import { Kopf, Karte } from '../teile/Geruest.tsx';
import { Fehlerkasten, ausFehler, type Fehlerlage } from '../teile/Formular.tsx';
import { useFrisch } from '../teile/Frisch.tsx';
import { Zustandschip, tagLang } from './Ne4Arbeit.tsx';
import { Suchfeld, passtSuche } from '../teile/Schluesselsuche.tsx';
import { Ne4Ordner, fehlendePflicht } from '../teile/Ne4Ordner.tsx';
import { MeldeDialog, VerzoegerungDialog } from './Ne4Tagesplan.tsx';
import { HausZahlen, TerminMarke } from '../teile/Ne4Bausteine.tsx';

export function Ne4FirmenAuftraege({ ich }: { ich: Anmelder }) {
  const [liste, setListe] = useState<any[] | null>(null);
  /* .592: aus der Glocke kommt das Haus mit (Neuer Termin, Absage, Nachricht der Dispo). */
  const [offen, setOffen] = useState<string | null>(() => { try { const x = sessionStorage.getItem('mds.ne4.oeffne'); sessionStorage.removeItem('mds.ne4.oeffne'); return x ?? offenAusAdresse('ne4_firmenauftraege'); } catch { return offenAusAdresse('ne4_firmenauftraege'); } });
  useEffect(() => { offenInAdresse('ne4_firmenauftraege', offen); }, [offen]);
  const [zuletzt, setZuletzt] = useState<string | null>(null);
  const [suche, setSuche] = useState('');
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const laden = () => api.ne4FirmaAuftraege().then(setListe).catch((f) => setFehler(ausFehler(f)));
  useEffect(() => { void laden(); }, []);
  useFrisch(laden);
  useEffect(() => {
    if (!zuletzt || offen) return;
    const t = setTimeout(() => document.querySelector(`tr[data-ne4-id="${zuletzt}"]`)?.scrollIntoView({ block: 'center' }), 60);
    return () => clearTimeout(t);
  }, [zuletzt, offen, liste]);
  if (offen) return <FirmaHaus ich={ich} id={offen} zu={() => { setZuletzt(offen); setOffen(null); void laden(); }} />;
  const zeilen = (liste ?? []).filter((a) => suche.replace(/[,;]/g, ' ').split(/\s+/).filter(Boolean).every((w) => passtSuche(w, a.kls_id, `${a.strasse ?? ''} ${a.hausnummer ?? ''}`, a.plz, a.ort, a.eigentuemer_org)));
  /* .595: der Teamname nur, wenn es mehr als ein Team gibt (Marvin: „musst du nicht dann da stehen haben,
     dass die Aufträge für dich als Team 1 disponiert sind"). */
  const mehrereTeams = new Set((liste ?? []).flatMap((a) => (a.termine ?? []).map((t: any) => t.team))).size > 1;
  return (
    <>
      <Kopf titel="NE4, Meine Aufträge" weg={liste ? `${liste.length} Häuser mit Termin` : ''}
            rechts={<Suchfeld wert={suche} setze={setSuche} mehr="Eigentümer" breit={280} />} />
      <div className="inhalt">
        <Fehlerkasten lage={fehler} />
        <Karte titel={`Häuser (${zeilen.length})`}>
          {liste && !zeilen.length && <div className="leise klein">Noch kein Haus mit Termin.</div>}
          {!!zeilen.length && (
            <table className="liste">
              <thead><tr><th>Baustelle</th><th>Termine</th><th>Zustand</th><th>Einheiten</th><th className="zahl">Connects</th><th className="zahl">Dateien</th></tr></thead>
              <tbody>{zeilen.map((a) => (
                <tr key={a.id} data-ne4-id={a.id} className={a.id === zuletzt ? 'gewaehlt' : undefined} onClick={() => setOffen(a.id)}>
                  <td><b style={{ fontSize: 15 }}>{a.strasse} {a.hausnummer}</b><div className="klein">{a.plz} {a.ort}</div><div className="klein leise">KLS {a.kls_id}{a.eigentuemer_org ? `, ${a.eigentuemer_org}` : ''}</div></td>
                  <td>{(a.termine ?? []).length
                    ? <div className="ne4-terminreihe">{(a.termine as any[]).map((t, i) => <TerminMarke key={i} t={t} team={mehrereTeams ? t.team : null} />)}</div>
                    : <span className="leise klein">kein Termin</span>}</td>
                  <td><Zustandschip z={a.zustand} inArbeit={a.in_arbeit_seit} /></td>
                  <td className="klein" style={{ whiteSpace: 'nowrap' }}>{a.etagen ?? '–'} Etagen<br />{a.wohneinheiten ?? '–'} WE, {a.ge ?? '–'} GE<br />{a.sl ?? '–'} SL</td>
                  <td className="zahl"><b>{a.connects_fertig}/{a.connects}</b></td>
                  <td className="zahl">{a.dateien}</td>
                </tr>))}</tbody>
            </table>
          )}
        </Karte>
      </div>
    </>
  );
}

export function FirmaHaus({ ich, id, zu }: { ich: Anmelder; id: string; zu: () => void }) {
  const [a, setA] = useState<any>(null);
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const [meldung, setMeldung] = useState<string | null>(null);
  const [eintrag, setEintrag] = useState('');
  const [laeuft, setLaeuft] = useState(false);
  const [melden, setMelden] = useState<{ termin: any; art: 'fertig' | 'nicht' | 'verzoegerung' } | null>(null);
  const schreibt = darf(ich, 'ne4.firmenauftraege.schreiben');
  /* .592: DER STATUSABLAUF WIE IN NE3: in Arbeit nehmen, fertig melden, nicht erledigt, Verzögerung. */
  const meldet = darf(ich, 'ne4.tagesplan.melden');
  const laden = () => api.ne4FirmaAuftrag(id).then(setA).catch((f) => setFehler(ausFehler(f)));
  useEffect(() => { void laden(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  useFrisch(laden);
  async function tu(f: () => Promise<any>, ok: string) {
    setLaeuft(true); setFehler(null); setMeldung(null);
    try { await f(); setMeldung(ok); await laden(); } catch (x) { setFehler(ausFehler(x)); } finally { setLaeuft(false); }
  }
  if (!a) return <><div className="kopf"><button type="button" className="knopf" onClick={zu}>&larr; zurück</button><h1>Haus</h1></div><div className="inhalt"><Fehlerkasten lage={fehler} /><div className="leise klein">Lade …</div></div></>;
  const fehlt = fehlendePflicht(a.dateien ?? [], a.ordner ?? []);
  const heute = new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' });
  const navi = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${a.strasse ?? ''} ${a.hausnummer ?? ''}, ${a.plz ?? ''} ${a.ort ?? ''}`)}`;
  return (
    <>
      <div className="kopf">
        <button type="button" className="knopf" onClick={zu}>&larr; zurück</button>
        <h1>{a.strasse} {a.hausnummer}, {a.plz} {a.ort}</h1>
        <span className="weg">{a.eigentuemer_org || a.artname}, KLS-ID {a.kls_id}</span>
        <Zustandschip z={a.zustand} inArbeit={a.in_arbeit_seit} />
        <div className="wachsen" />
        <a className="knopf klein" href={navi} target="_blank" rel="noreferrer">Navigation</a>
      </div>
      <div className="inhalt">
        <Fehlerkasten lage={fehler} />
        {meldung && <div className="hinweis erledigt">{meldung}</div>}
        <div className="ne4-firma-raster">
          <div>
            <Karte titel="Haus">
              <HausZahlen a={a} connects={{ fertig: (a.wohnungen ?? []).filter((w: any) => w.erledigt_am).length, alle: (a.wohnungen ?? []).length }} />
            </Karte>
            <Karte titel="Termine">
              {!(a.termine ?? []).length && <div className="leise klein">Kein Termin.</div>}
              {(a.termine ?? []).map((t: any) => (
                <div key={t.id} className="ne4-termin-gesetzt">
                  <div className="ne4-termin-tag">{tagLang(t.tag)}</div>
                  <div className="ne4-termin-zeit">{t.beginn} Uhr{t.dauer_min ? `, ${Math.round(t.dauer_min / 60)} h` : ''}, {t.team}{t.block_tag ? `, Tag ${t.block_tag} von ${t.block_tage}` : ''}</div>
                  <div className="klein">{t.zustand === 'ausgefuehrt' ? `Fertig gemeldet${t.bericht ? `: ${t.bericht}` : ''}` : t.zustand === 'nicht_erledigt' ? `Nicht erledigt: ${t.grund ?? ''}` : t.begonnen_am ? `In Arbeit seit ${zeitpunkt(t.begonnen_am)}` : 'gebucht'}</div>
                  {meldet && t.zustand === 'gebucht' && (
                    <div className="reihe" style={{ gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                      {!t.begonnen_am && <button type="button" className="knopf klein haupt" disabled={laeuft || t.tag > heute}
                              title={t.tag > heute ? 'Geht ab dem Termintag' : ''}
                              onClick={() => void tu(() => api.ne4Begonnen(t.id), 'In Arbeit genommen, die Dispo sieht es an der Glocke.')}>{t.tag > heute ? `In Arbeit nehmen (ab ${t.tag.slice(8, 10)}.${t.tag.slice(5, 7)}.)` : 'In Arbeit nehmen'}</button>}
                      <button type="button" className={'knopf klein' + (t.begonnen_am ? ' haupt' : '')} disabled={laeuft} onClick={() => setMelden({ termin: t, art: 'fertig' })}>Fertig melden</button>
                      <button type="button" className="knopf klein" disabled={laeuft} onClick={() => setMelden({ termin: t, art: 'nicht' })}>Nicht erledigt</button>
                      <button type="button" className="knopf klein" disabled={laeuft} onClick={() => setMelden({ termin: t, art: 'verzoegerung' })}>Verzögerung melden</button>
                    </div>
                  )}
                </div>
              ))}
            </Karte>
            <Karte titel="Ansprechpartner vor Ort">
              <div><b>{a.eigentuemer_org || [a.vorname, a.name].filter(Boolean).join(' ') || 'ohne Namen'}</b></div>
              {a.eigentuemer_org && [a.vorname, a.name].filter(Boolean).length > 0 && <div className="klein">{[a.vorname, a.name].filter(Boolean).join(' ')}</div>}
              <div className="reihe" style={{ gap: 8, flexWrap: 'wrap', margin: '8px 0' }}>
                {a.mobil && <a className="knopf haupt ne4-anruf-knopf" href={`tel:${a.mobil.replace(/\s+/g, '')}`}>📞 Mobil anrufen<span>{a.mobil}</span></a>}
                {a.telefon && <a className="knopf haupt ne4-anruf-knopf" href={`tel:${a.telefon.replace(/\s+/g, '')}`}>📞 Festnetz anrufen<span>{a.telefon}</span></a>}
                {!a.mobil && !a.telefon && <span className="leise klein">keine Rufnummer</span>}
              </div>
              {a.notiz && <div className="klein" style={{ marginTop: 4 }}><b>Notiz:</b> {a.notiz}</div>}
            </Karte>
            <Karte titel={`Connects (${(a.wohnungen ?? []).filter((w: any) => w.erledigt_am).length} von ${(a.wohnungen ?? []).length} fertig)`}>
              {!(a.wohnungen ?? []).length && <div className="leise klein">Noch keine Connects angelegt.</div>}
              <table className="liste"><tbody>
                {(a.wohnungen ?? []).map((w: any) => (
                  <tr key={w.id} style={{ cursor: 'default' }}>
                    <td><b>{w.bezeichnung}</b>{w.lage && <div className="klein leise">{w.lage}</div>}</td>
                    <td className="klein">{w.termin_tag ? tagLang(w.termin_tag) : <span className="leise">kein Termin</span>}</td>
                    <td className="klein">{w.erledigt_am ? <span style={{ color: 'var(--erledigt)' }}>✓ fertig {datum(w.erledigt_am)}</span> : w.grund ? <span className="fehlertext">{w.grund}</span> : 'offen'}</td>
                  </tr>
                ))}
              </tbody></table>
              <div className="klein leise">Was gebaut ist, tragt ihr beim „Fertig melden" oder „Nicht erledigt" je Connect ein, mit Wohnung und Kommentar.</div>
            </Karte>
            <Karte titel="Infos">
              {schreibt && (
                <div style={{ marginBottom: 10 }}>
                  <textarea value={eintrag} rows={3} style={{ width: '100%' }} placeholder="Nachricht an die Dispo zu diesem Haus …" onChange={(e) => setEintrag(e.target.value)} />
                  <button type="button" className="knopf klein haupt" disabled={laeuft || !eintrag.trim()}
                          onClick={() => { const t = eintrag.trim(); setEintrag(''); void tu(() => api.ne4FirmaEintrag(a.id, t), 'Eintrag gespeichert, die Dispo sieht ihn in der Auftragsinfo.'); }}>Eintrag schreiben</button>
                </div>
              )}
              {!(a.info ?? []).length && <div className="leise klein">Noch keine Infos.</div>}
              <ul className="verlauf">
                {(a.info ?? []).map((k: any) => (
                  <li key={k.id}><span className="wann">{zeitpunkt(k.wann)}</span><span className="wer">{k.wer ?? 'System'}</span><span>{k.text}</span></li>
                ))}
              </ul>
            </Karte>
          </div>
          <div>
            <Karte titel="Dateien" rechts={fehlt.length ? <span className="merker warnung">fehlt: {fehlt.join(', ')}</span> : undefined}>
              <Ne4Ordner dateien={a.dateien ?? []} ordner={a.ordner ?? []} darfLaden={schreibt}
                         hochladen={(o, d) => api.ne4FirmaDatei(a.id, o, d)}
                         fertig={(text, f) => { if (f) setFehler(ausFehler(f)); else { setMeldung(text); void laden(); } }} />
            </Karte>
          </div>
        </div>
      </div>
      {melden && melden.art !== 'verzoegerung' && (
        <MeldeDialog termin={{ ...melden.termin, strasse: a.strasse, hausnummer: a.hausnummer, name: a.eigentuemer_org ?? a.name, art: a.art, wohnungen: a.wohnungen, etagen: a.etagen }} art={melden.art} positionen={[]}
                     fehlendePflicht={melden.art === 'fertig' && !(a.termine ?? []).some((x: any) => x.zustand === 'gebucht' && x.id !== melden.termin.id) ? fehlt : []}
                     zu={() => setMelden(null)} fertig={() => { setMelden(null); setMeldung(melden.art === 'fertig' ? 'Fertig gemeldet.' : 'Nicht erledigt gemeldet; die Dispo meldet sich.'); void laden(); }} />
      )}
      {melden?.art === 'verzoegerung' && (
        <VerzoegerungDialog termin={melden.termin} titel={`${a.strasse} ${a.hausnummer}`} zu={() => setMelden(null)}
                            fertig={() => { setMelden(null); setMeldung('Verzögerung gemeldet, die Dispo sieht sie an der Glocke.'); void laden(); }} />
      )}
    </>
  );
}
